import { sdk } from 'src/utilities/sdk';
import { Employee, EmployeeResponse } from 'src/types/Employee';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

export const getEmployeeGetEndpoint = (
  corpId: string,
  employeeId: string
): string => `/corp-admin/${corpId}/diners/${employeeId}`;

export async function getEmployee(
  corpId: string,
  employeeId: string
): Promise<Employee> {
  const employeeData: EmployeeResponse = await sdk.http.get(
    getEmployeeGetEndpoint(corpId, employeeId)
  );

  return camelizeResponseData(employeeData);
}
